import { 
  VALIDATE_SURA_TOKEN_SUCCESS,
  VALIDATE_SURA_TOKEN
} from "../actions/paymentAccountActions";

const initialState = {
  token: null,
  jwtSura: null,
  userType: null
}

export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  switch(type){
    case VALIDATE_SURA_TOKEN:
      newState = { jwtSura: payload }
      return { ...state, ...newState }
    case VALIDATE_SURA_TOKEN_SUCCESS:
      newState = { token: payload}
      return { ...state, ...newState }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/paymentAccountReducer.js